<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">{{data.content}}</div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button *ngIf="data.status === 'Approve'" mat-button class="yes-button" (click)="approveReimbursement(data.id)" cdkFocusInitial>{{data.confirmText}}</button>
        <button *ngIf="data.status === 'Reject'" mat-button class="reject-button" (click)="declineReimbursement(data.id)" cdkFocusInitial>{{data.confirmText}}</button>
    </div>
</div>